<template>
    <div class="ma-0 pa-0 mt-n10">
    <v-container>
      <v-row class="mb-n5">
        <v-col cols="2">
          <v-select :items="getAccessorList" v-model="assessorSelectedFile"
          class="input-text-size mt-8" label="Select Assessor Profile"
          item-text="name" item-value="name" @change="onAssessorChange" />
        </v-col>
        <v-col cols="3">
          <div class="landmark-ftp-box mt-10 mb-6 rounded elevation-4">
            <v-row no-gutters align="center" class="px-3 py-1">
              <!-- Landmark FTP only for the counties it serves; the uploaded-files list
              below is the county's own and stays either way. A county with no folder on
              that server (Tulsa) would otherwise fail this listing on every page load. -->
              <v-col cols="8" v-if="landmarkFtpApplies">
                <v-select
                  v-model="selectedLandmarkFile"
                  :items="landmarkFtpFiles"
                  item-text="label"
                  item-value="name"
                  label="Select Landmark FTP File"
                  :loading="landmarkFtpLoading"
                  :no-data-text="landmarkNoDataText"
                  clearable
                  class="input-text-size"
                />
              </v-col>
              <v-col cols="4" class="text-center" v-if="landmarkFtpApplies">
                <v-btn class="input-text-size" text color="blue darken-1"
                  :loading="unzipLoading" :disabled="unzipLoading" @click="unzipFtpFile">
                  Unzip
                </v-btn>
              </v-col>
              <v-col cols="8">
                <v-select
                v-model="selectedFileName"
                class="input-text-size ma-0 pa-0"
                :items="fileList"
                label="Uploaded files list"
                item-text="name"
                item-value="name"/>
              </v-col>
              <!-- d-flex/flex-nowrap rather than text-center: the two icon buttons
                   otherwise stack, since the column is narrow enough for them to
                   break onto separate lines -->
              <v-col cols="4" class="d-flex align-center justify-center flex-nowrap">
                <v-btn icon small color="blue darken-1" class="ma-0 pa-0"
                  title="Download the selected file"
                  :loading="downloadLoading" :disabled="downloadLoading"
                  @click="handleDownloadFileFromBackend">
                  <v-icon small>{{ icons.mdiDownload }}</v-icon>
                </v-btn>
                <v-btn icon small color="red darken-1" class="ma-0 pa-0 ml-2"
                  title="Delete the selected file"
                  @click="handleDeleteFileInBackend">
                  <v-icon small>{{ icons.mdiDelete }}</v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </div>
          </v-col>
        <v-col cols="3">
        <AssessorUpdateImportFiles @loadCRUDList="loadAfterImport" :showImportTimmings="false"
         :makeBackupToTrue="true" dynamicNameForImport="Import & Compare"
         :dynamicUpdateInputs="dynamicUpdateInputsValues" :selectedFileName="selectedFileName"
         :assessorSelectedFile="assessorSelectedFile" />
        </v-col>
        <v-col cols="4" class="mt-12">
          <v-checkbox class="input-text-size radio-and-checekbox-size pa-0 ma-0"
            label="Compare Unpaids Only" v-model="unpaidsCheckBoxOnly"
            @change="unpaidsCheckBoxClick"/>
          <!-- <v-checkbox class="input-text-size radio-and-checekbox-size pa-0 ma-0"
            label="Create Adjustment Records" /> -->
            <!-- Hidden: mass-update is too risky for assessor data (see Asana 1217275015692966).
                 Keeping updateAllOwnerRecords() in place in case a county ever asks for it back.
            <v-btn class="input-text-size" text color="blue darken-1"
              @click="updateAllOwnerRecords">Update All</v-btn> -->
            <v-btn class="input-text-size" text color="blue darken-1" @click="updateOwnerRecords">
              Update Selected Record
            </v-btn>
            <v-btn class="input-text-size" text color="blue darken-1" @click="createWorkFile">
              Create Work File
            </v-btn>
            <span v-if="secondPassStatus === 'running'" class="input-text-size grey--text">
              Generating missing-records report…
            </span>
            <template v-if="secondPassStatus === 'complete'">
              <v-btn class="input-text-size" text color="green darken-2" @click="printMissingReport">
                Print Missing Report
              </v-btn>
              <v-btn class="input-text-size" text color="green darken-2" @click="downloadMissingCsv">
                Download CSV
              </v-btn>
            </template>
        </v-col>
      </v-row>
      <p class="input-text-size radio-and-checekbox-size pa-0 ma-0 ml-4 mt-n8">
        Record Count = {{ assessorUpdateStats.count }}</p>
      <p class="input-text-size radio-and-checekbox-size pa-0 ma-0 ml-4">
        #{{ assessorUpdateStats.misMatchedRecordsCount }} of mismatched records</p>
      <div>
        <CRUDList :canAdd="false" :headersWithColsSpan="headersWithColsSpan"
          :canEdit="false" :canSave="false" :showSelect="false" :canDeleteInDialog="false"
          :enableFixedHeaders="true" :displayTopPagination="false"
          :headers="headers" :baseCrudKey="baseCrudKey" ref="crudList"
          tableWrapperDynamicClassname='elevation-3 ma-3 pt-0 pa-1 taxroll-table-wrapper'
          tableDynamicClassname='taxroll-custom-table' tableDynamicHeight='300'
          :defaultSortBy="defaultSortBy" @loadCRUDList="handleLoadTransaction"
          :loadingData="gridLoading.flag" :loadingText="gridLoading.text"
          @onSingleClicked="handleSingleOrArrowClick" @onArrowUpOrDown="handleSingleOrArrowClick">
        </CRUDList>
      </div>
      <div>
        <v-row class="ml-1">
          <v-col cols="3">
            <p class="input-text-size">Current Treasurer's Consolidated Name/Address</p>
            <v-textarea class="input-text-size pa-0  mt-n1 dec-line-height" outlined rows="8"
            v-model="consolidatedView"/>
          </v-col>
          <v-col cols="3">
            <p class="input-text-size">Current Assessor's Consolidated Name/Address</p>
            <v-textarea class="input-text-size pa-0  mt-n1 dec-line-height" outlined rows="8"
            v-model="assessorConsolidatedView"/>
            <p class="input-text-size white-space-pre-line mt-n4">
              {{ getConsolidatedDeeddetails() }}</p>
          </v-col>
          <v-col cols="6">
            <p class="input-text-size">Suggested Name/Address</p>
            <v-row>
              <v-col cols="6" v-if="replaceOwnerNameOnAssessorUpdates">
                <v-text-field class="input-text-size pa-0 mt-n1"
                label="Name 1" v-model="selectedObject.importName1"
                v-uppercase=globalSettingItem.conEverythingToCaps />
              </v-col>
              <v-col cols="6" v-else>
                <v-text-field class="input-text-size pa-0 mt-n1"
                label="Name 1" v-model="selectedObject.name1"
                v-uppercase=globalSettingItem.conEverythingToCaps />
              </v-col>
              <v-col cols="6" v-if="replaceOwnerNameOnAssessorUpdates">
                <v-text-field class="input-text-size pa-0 mt-n1"
                label="Name 2" v-model="selectedObject.importName2"
                v-uppercase=globalSettingItem.conEverythingToCaps />
              </v-col>
              <v-col cols="6" v-else>
                <v-text-field class="input-text-size pa-0 mt-n1"
                label="Name 2" v-model="selectedObject.name2"
                v-uppercase=globalSettingItem.conEverythingToCaps />
              </v-col>
              <v-col cols="6">
                <v-text-field class="input-text-size pa-0 mt-n8"
                v-uppercase=globalSettingItem.conEverythingToCaps
                :readonly="disableInCareOfFields" :tabindex="disableInCareOfFields ? -1 : 0"
                label="C/O Name 1" v-model="selectedObject.importCareOfName1" />
              </v-col>
              <v-col cols="6">
                <v-text-field class="input-text-size pa-0 mt-n8"
                v-uppercase=globalSettingItem.conEverythingToCaps
                :readonly="disableInCareOfFields" :tabindex="disableInCareOfFields ? -1 : 0"
                label="C/O Name 2" v-model="selectedObject.importCareOfName2" />
              </v-col>
              <v-col cols="6">
                <v-text-field class="input-text-size pa-0 mt-n8"
                v-uppercase=globalSettingItem.conEverythingToCaps
                label="Address 1" v-model="selectedObject.importAddress1"/>
              </v-col>
              <v-col cols="6">
                <v-text-field class="input-text-size pa-0 mt-n8"
                v-uppercase=globalSettingItem.conEverythingToCaps
                label="Address 2" v-model="selectedObject.importAddress2" />
              </v-col>
              <v-col cols="6">
                <v-text-field class="input-text-size pa-0 mt-n8"
                v-uppercase=globalSettingItem.conEverythingToCaps
                label="Address 3" v-model="selectedObject.importAddress3" />
              </v-col>
              <v-col cols="6">
                <v-text-field class="input-text-size pa-0 mt-n8"
                v-uppercase=globalSettingItem.conEverythingToCaps
                label="Address 4" v-model="selectedObject.importAddress4" />
              </v-col>
              <v-col cols="4">
                <v-text-field class="input-text-size pa-0 mt-n8"
                v-uppercase=globalSettingItem.conEverythingToCaps
                label="City" v-model="selectedObject.importCity" />
              </v-col>
              <v-col cols="4">
                <v-text-field class="input-text-size pa-0 mt-n8"
                v-uppercase=globalSettingItem.conEverythingToCaps
                label="State" v-model="selectedObject.importState" />
              </v-col>
              <v-col cols="4">
                <v-text-field class="input-text-size pa-0 mt-n8"
                v-uppercase=globalSettingItem.conEverythingToCaps
                label="Zip" v-model="selectedObject.importZip" />
              </v-col>
          </v-row>
          </v-col>
        </v-row>
      </div>
    </v-container>
  </div>
</template>

<script>
import { mdiDelete, mdiDownload } from '@mdi/js';
import {
  mapActions, mapGetters, mapMutations, mapState,
} from 'vuex';
import CRUDList from '../../../common/base/crud-2.0/CRUDList.vue';
import {
  amountToNumber, defaultGridLoading, manageGridLoading, zipDeFormat, zipFormat,
} from '../../../../util/shared/vue-global';
import AssessorUpdateImportFiles from '../../../common/import/AssessorUpdateImportFiles.vue';
import { commonFuncForFilterMtgCoProc } from '../../common-utils/CommonTaxFunctionalities';
import { clients } from '../../../../util/clients';
import {
  AssessorNameAddressUpdateHeadersTwo, AssessorNameAddressUpdateListHeader, shouldShiftAddressLinesForNewOwner,
} from '../TaxRollAdjustmentsUtils/AssessorNameAddressUpdate.Utils';
import {
  ftpEmptyMessage,
  ftpErrorMessage,
  readFtpFileList,
  readFtpMessage,
  readFtpPath,
} from '../../../../util/shared/ftp-file-list';
import { usesLandmarkFtp } from '../../SpecialTaxItems/newTaxRoll/SpecialTaxItems.utils';
import { transformMapperListFields } from '../../../../util/shared/transform';
import { getWorkstationNumber } from '../../../../util/workstation-util';
import GlobalToCaps from '../../../../util/shared/GlobalToCaps.mixin.vue';
import { commonFuncForConsolidateView, folderNameForUploadToBackend } from '../../common-utils/tax-common.util';
import { toShortDate } from '../../../../util/shared/tmc-global';
import { getRawJwt } from '../../../../util/jwt';

const { backendRest } = clients.direct;

export default {
  name: 'AssessorUpdate',
  mixins: [GlobalToCaps],
  components: {
    CRUDList,
    AssessorUpdateImportFiles,
  },
  data() {
    return {
      baseCrudKey: 'assessorNameAddressUpadate',
      headers: AssessorNameAddressUpdateListHeader,
      headersWithColsSpan: AssessorNameAddressUpdateHeadersTwo,
      gridLoading: defaultGridLoading(),
      subProgram: 'Assessor Name Address Update Files',
      unpaidsCheckBoxOnly: true,
      dynamicUpdateInputsValues: { type: 'constant', prop: 'assessorIgnoreTaxPaidFlag', value: 1 },
      selectedObject: {},
      consolidatedView: '',
      assessorConsolidatedView: '',
      landmarkFtpFiles: [],
      selectedLandmarkFile: null,
      landmarkFtpLoading: false,
      // Why the Landmark list is empty, shown inside the dropdown (ftp-file-list.js).
      landmarkFtpMessage: '',
      landmarkFtpLoaded: false,
      // The county's Assessor Company decides whether there is a Landmark FTP to read at
      // all, and it arrives with the taxConfig loadMappers() asks for - so the listing
      // waits for that rather than firing blind on created().
      taxConfigLoaded: false,
      unzipLoading: false,
      // Second pass: background report of treasurer records missing from the
      // assessor file. Kicked off automatically after each import & compare.
      secondPassStatus: 'idle', // idle | running | complete | error
      secondPassJobId: null,
      secondPassPdfUrl: '',
      secondPassCsvUrl: '',
      secondPassInterval: null,
      secondPassCount: 0,
      selectedFileName: '',
      assessorSelectedFile: '',
      fileList: [],
      downloadLoading: false,
      icons: {
        mdiDelete,
        mdiDownload,
      },
    };
  },
  created() {
    // loadMappers() is what fetches the taxConfig the Landmark box is decided by; the
    // listing itself is started by the landmarkFtpApplies watcher once that has landed.
    this.loadMappers();
    this.loadExtractedFiles();
  },
  computed: {
    ...mapGetters('base/crud', [
      'criteria',
      'items',
    ]),
    ...mapGetters('auth/token', ['authUser']),
    ...mapState({
      assessorUpdateStats: (state) => state.tax.taxRollAdjustments.assessorUpdateStats,
      globalSettingItem: (state) => state.SystemConfig.globalSettingItem,
      taxSettingItem: (state) => state.SystemConfig.taxSettingItem || {},
    }),
    /* Same rule as Import & Balance (usesLandmarkFtp): the companies whose files come
       off the Landmark FTP, plus any county that has not set one - a blank setting must
       not take the box away from a Landmark county that never filled it in. */
    landmarkFtpApplies() {
      return this.taxConfigLoaded && usesLandmarkFtp(this.taxSettingItem.assessorCompany);
    },
    landmarkNoDataText() {
      if (this.landmarkFtpLoading) return 'Reading the Landmark FTP server...';
      return this.landmarkFtpMessage || 'No Landmark FTP files';
    },
    getMappersItems() {
      const itemData = this.items('transform-mapper-list');
      return itemData;
    },
    getItems() {
      const itemData = this.items(this.baseCrudKey);
      return itemData;
    },
    defaultSortBy() {
      return [
        {
          column: 'importTaxId',
          direction: 'asc',
        },
      ];
    },
    getAccessorList() {
      const itemData = this.getMappersItems;
      const { filteredTaxItemData } = commonFuncForFilterMtgCoProc(itemData, this.subProgram);
      return filteredTaxItemData;
    },
    replaceOwnerNameOnAssessorUpdates() {
      return this.taxSettingItem.replaceOwnerNameOnAssessorUpdates || false;
    },
    addPercentToCareOfNamesFromAssessor() {
      return this.taxSettingItem.addPercentToCareOfNamesFromAssessor || false;
    },
    shiftAddressLineOnAssessorUpdates() {
      return this.taxSettingItem.shiftAddressLineOnAssessorUpdates || false;
    },
    // This panel is WYSIWYG - whatever sits in its C/O Name boxes is written to the tax roll
    // verbatim by assessorNameAddressUpdateFilesUpdateFunc - so the county setting has to lock
    // them here as well as being enforced on the way in. No admin override.
    disableInCareOfFields() {
      return this.taxSettingItem.disableInCareOfFields || false;
    },
  },
  methods: {
    ...mapActions(['reAuth', 'custumColrFlashMsg']),
    ...mapActions('config', [
      'loadTransformMappers',
    ]),
    ...mapMutations('tax/MortgageCoProcessing', [
      'setPipeline',
    ]),
    ...mapActions('SystemConfig', [
      'loadConfig',
    ]),
    ...mapActions('tax/taxRollAdjustments', [
      'getAssessorNameAddressUpdateFiles',
      'upsertAssessorNameAddressUpdateFiles',
      'upsertAllAssessorNameAddressUpdateFiles',
      'getAssessorNameAddressUpdateFilesStats',
      'upsertCreateWorkFileForAssessorUpdate',
      'startAssessorSecondPassReport',
      'getAssessorSecondPassReportStatus',
    ]),
    ...mapActions('tax/commonImport', [
      'deleteFileInBackend',
      'downloadFileFromBackend',
    ]),
    ...mapMutations('base/crud', ['setCriteria', 'setItems']),
    ...mapActions(['flashSuccess', 'flashError', 'flashInfo', 'flashWarn']),
    async loadLandmarkFtpFiles() {
      this.landmarkFtpLoading = true;
      this.landmarkFtpMessage = '';
      try {
        await this.reAuth();
        const { data } = await backendRest.get('/landmark/ftp/files');
        this.landmarkFtpFiles = readFtpFileList(data);
        if (!this.landmarkFtpFiles.length) {
          // The server's own account of the empty result when it gave one ("No Landmark
          // folder for this county") - a 200, so it belongs in the dropdown, not a flash.
          this.landmarkFtpMessage = readFtpMessage(data) || ftpEmptyMessage(readFtpPath(data));
        }
      } catch (e) {
        // The reason the FTP server gave, not "failed to load" - see TKT-000856.
        this.landmarkFtpFiles = [];
        this.landmarkFtpMessage = ftpErrorMessage(e);
        this.flashError(this.landmarkFtpMessage);
      } finally {
        this.landmarkFtpLoading = false;
      }
    },
    async loadExtractedFiles() {
      try {
        await this.reAuth();
        const { data } = await backendRest.get('/landmark/ftp/extracted-files');
        this.fileList = Array.isArray(data) ? data : [];
      } catch (e) {
        this.flashError('Failed to load the extracted file list.');
      }
    },
    async unzipFtpFile() {
      if (!this.selectedLandmarkFile) {
        this.flashInfo('Please select a Landmark FTP file to unzip.');
        return;
      }
      // downloading and expanding the archive can take a while, so the button
      // spins and stays disabled until the extracted list has been refreshed
      this.unzipLoading = true;
      try {
        await this.reAuth();
        await backendRest.get('/landmark/ftp/extractfiles', {
          params: { fileName: this.selectedLandmarkFile },
        });
        // the archive just expanded into ASSESSOR_UNZIPPED_DIR, so refresh the list
        await this.loadExtractedFiles();
        this.flashSuccess('Successfully unzippped FTP files.');
      } catch (e) {
        this.flashError('Failed to unzip Landmark FTP files.');
      } finally {
        this.unzipLoading = false;
      }
    },
    loadMappers() {
      // Flag flips either way: a config that failed to load must leave the screen
      // behaving as it did before, not sitting on a box that never appears.
      this.loadConfig({ requiredScope: 'taxConfig' })
        .catch(() => {})
        .finally(() => { this.taxConfigLoaded = true; });
      if (!this.getMappersItems.length) {
        this.loadTransformMappers({
          criteria: { type: 'import', program: 'TAX' },
          fields: { ...transformMapperListFields },
          baseCrudKey: 'transform-mapper-list',
        });
      }
    },
    loadAfterImport() {
      // First pass finished: refresh the grid as normal, then automatically
      // kick off the background second pass (no user action required).
      this.handleLoadTransaction();
      this.startSecondPass();
    },
    async startSecondPass() {
      this.stopSecondPassPolling();
      this.secondPassStatus = 'running';
      this.secondPassPdfUrl = '';
      this.secondPassCsvUrl = '';
      const data = await this.startAssessorSecondPassReport();
      if (!data || !data.jobId) {
        this.secondPassStatus = 'error';
        return;
      }
      this.secondPassJobId = data.jobId;
      this.secondPassInterval = setInterval(async () => {
        const status = await this.getAssessorSecondPassReportStatus({ jobId: this.secondPassJobId });
        if (!status) return;
        if (status.status === 'complete') {
          this.stopSecondPassPolling();
          this.secondPassStatus = 'complete';
          this.secondPassCount = status.total || 0;
          this.secondPassPdfUrl = this.buildReportUrl(status.pdfUrl);
          this.secondPassCsvUrl = this.buildReportUrl(status.csvUrl);
          this.flashSuccess(`Missing-records report is ready (${this.secondPassCount} record(s)).`);
        } else if (status.status === 'error') {
          this.stopSecondPassPolling();
          this.secondPassStatus = 'error';
          this.flashError(status.errorMessage || 'The missing-records report failed to generate.');
        }
      }, 2500);
    },
    buildReportUrl(relativeUrl) {
      if (!relativeUrl) return '';
      // relativeUrl already carries a `?type=` query string; append the JWT so
      // the browser (new tab / direct GET) is authorized.
      return `${backendRest.defaults.baseURL}/${relativeUrl}&token=${getRawJwt()}`;
    },
    stopSecondPassPolling() {
      if (this.secondPassInterval) {
        clearInterval(this.secondPassInterval);
        this.secondPassInterval = null;
      }
    },
    printMissingReport() {
      if (this.secondPassPdfUrl) window.open(this.secondPassPdfUrl);
    },
    downloadMissingCsv() {
      if (this.secondPassCsvUrl) window.open(this.secondPassCsvUrl);
    },
    onAssessorChange(val) {
      const itemData = this.getMappersItems;
      const { filteredTaxItemData } = commonFuncForFilterMtgCoProc(itemData, this.subProgram);
      const [filtTaxData] = filteredTaxItemData.filter((ft) => ft.name === val);
      this.setPipeline(filtTaxData || {});
    },
    async handleDownloadFileFromBackend() {
      if (!this.selectedFileName) {
        this.flashInfo('Please select a file to download.');
        return;
      }
      this.downloadLoading = true;
      try {
        await this.downloadFileFromBackend({
          folderName: folderNameForUploadToBackend.assessorUnzippedFolder,
          fileName: this.selectedFileName,
        });
      } finally {
        this.downloadLoading = false;
      }
    },
    async handleDeleteFileInBackend() {
      if (!this.selectedFileName) {
        this.flashWarn('Please select a file and profile');
        return;
      }
      await this.deleteFileInBackend({
        folderName: folderNameForUploadToBackend.assessorUnzippedFolder,
        fileName: this.selectedFileName,
      });
      // the selection just stopped existing, so clear it rather than leaving a name
      // in the box that Import would then fail to find
      this.selectedFileName = '';
      this.loadExtractedFiles();
    },
    // we may remove this function later on if not needed in future
    async updateAllOwnerRecords() {
      const ids = (this.getItems || []).map((ft) => ft._id);
      const wkstNumber = amountToNumber(getWorkstationNumber());
      const updatedItem = { ids };
      updatedItem.userName = this.authUser;
      updatedItem.wkstNumber = wkstNumber;

      if ((ids || []).length) {
        await this.upsertAllAssessorNameAddressUpdateFiles({ item: updatedItem });
        this.handleLoadTransaction();
      }
    },
    async createWorkFile() {
      const wkstID = getWorkstationNumber();
      const upsert = {
        wkstID: Number(wkstID),
      };

      const response = await this.upsertCreateWorkFileForAssessorUpdate({ upsert });
      const criteria = {
        name: response.name,
      };
      if (response.statusCodes === 200) {
        this.flashSuccess('Work file created successfully');
        // user TR Browse Base crud key for opend on created TR work file
        this.setCriteria(['browseListNames', criteria]);
        const route = '/tax/trworkfile/browse';
        this.$router.push(route);
      } else {
        this.flashError('Failed to create work file');
      }
    },
    async updateOwnerRecords() {
      const {
        importTaxId, importZip, importTaxYear,
      } = this.selectedObject;
      if (importTaxId && importTaxYear) {
        const zip = zipDeFormat(importZip);
        const wkstNumber = amountToNumber(getWorkstationNumber());
        const updatedItem = this.selectedObject;
        updatedItem.userName = this.authUser;
        updatedItem.wkstNumber = wkstNumber;
        updatedItem.zip = zip;
        updatedItem.importZip = zip;
        delete updatedItem.posted;
        const isUpdated = await this.upsertAssessorNameAddressUpdateFiles({ item: updatedItem });
        if (isUpdated) {
        // to update the updated flag in the list
          const items = this.items(this.baseCrudKey);
          const itemIndex = items.findIndex((ft) => ft._id === updatedItem._id);
          if (itemIndex !== -1) {
            items[itemIndex].isItUpadtedToTaxInquiryCollection = true;
            this.setItems(this.baseCrudKey, items);
          }
        }
        // to select next record
        const keyDownForRowSel = { key: 'ArrowDown' };
        this.$refs.crudList.keyboardShortCutFunc(keyDownForRowSel);
      } else this.custumColrFlashMsg({ msg: 'Please select a record' });
    },
    handleLoadTransaction() {
      manageGridLoading(this, true, 'Searching...');
      const criteria = this.criteria(this.baseCrudKey);
      // this should always show mismatched records
      criteria.isItMatchedOrNot = false;
      this.getAssessorNameAddressUpdateFilesStats({ });
      this.getAssessorNameAddressUpdateFiles({
        criteria,
        baseCrudKey: this.baseCrudKey,
        postProcessTrans: this.postProcessAssessorNameAddressUpdateFiles,
      }).finally(() => {
        manageGridLoading(this, false);
      });
    },
    postProcessAssessorNameAddressUpdateFiles(items) {
      return items.map((item) => ({
        ...item,
        // this tempName1, tempName2 are used to store the name1, name2 values before the update
        tempName1: item.name1 || '',
        tempName2: item.name2 || '',
      }));
    },
    handleConsolidateView() {
      return commonFuncForConsolidateView(this.selectedObject);
    },
    handleAssessorConsolidateView(dataObj) {
      const obj = dataObj || this.selectedObject;
      const arrOfKeysOne = ['importName1', 'importName2'];
      const arrOfKeysTwo = ['importCareOfName1', 'importCareOfName2'];
      const arrOfKeysThree = ['importAddress1', 'importAddress2', 'importAddress3', 'importAddress4'];
      const arrOfKeysFour = ['importCity', 'importState', 'importZip'];

      // Step 1: Names
      const val1 = arrOfKeysOne
        .map((ft) => (obj[ft] && obj[ft].trim()) || '')
        .filter(Boolean);

      // Step 2: In-care-of, first one gets C/O (unless it already starts with %)
      const val2 = arrOfKeysTwo
        .map((ft) => (obj[ft] && obj[ft].trim()) || '')
        .filter(Boolean)
        .map((line, index) => (index === 0 && !line.startsWith('%') ? `C/O ${line}` : line));

      // Step 3: Addresses
      const val3 = arrOfKeysThree
        .map((ft) => (obj[ft] && obj[ft].trim()) || '')
        .filter(Boolean);

      // Step 4: City + State + ZIP merged
      let val4 = arrOfKeysFour
        .map((ft, i) => (i === 2 ? zipFormat(obj[ft]) : (obj[ft] && obj[ft].trim()) || ''))
        .filter(Boolean);
      val4 = [val4.join(' ')]; // Merge into one line
      const val5 = obj.country ? [obj.country] : [];

      // Combine all
      const allLines = [...val1, ...val2, ...val3, ...val4, ...val5];

      return allLines.join('\n');
    },
    handleSingleOrArrowClick(fromCrud) {
      if (!this.replaceOwnerNameOnAssessorUpdates) {
        this.selectedObject = { ...fromCrud };
        const importName = (this.selectedObject.importName1 || '').trim();
        const treasurerName = (this.selectedObject.name1 || '').trim();
        if (importName && treasurerName
            && importName.toLowerCase() !== treasurerName.toLowerCase()) {
          const prefix = this.addPercentToCareOfNamesFromAssessor ? '%' : 'C/O';
          // Shift the existing lines down when Address 1 already holds a
          // DIFFERENT line, so a name or legal continuation parked there is kept
          // instead of being overwritten. If Address 1 already carries this same
          // care-of name, overwrite in place so it is not duplicated into
          // Address 2. Mirrors assessorNameAddressUpdateFilesUpdateAllFunc
          // exactly (down to not honoring shiftAddressLineOnAssessorUpdates,
          // which the backend never did either) so Update All always produces
          // the same record as this suggestion.
          if (shouldShiftAddressLinesForNewOwner(this.selectedObject.importAddress1, importName)) {
            this.selectedObject.importAddress4 = this.selectedObject.importAddress3 || '';
            this.selectedObject.importAddress3 = this.selectedObject.importAddress2 || '';
            this.selectedObject.importAddress2 = this.selectedObject.importAddress1 || '';
          }
          this.selectedObject.importAddress1 = `${prefix} ${importName}`;
        }
      } else {
        // if importName1 and importName2 are not present,
        // then use the importCareOfName1 and importCareOfName2
        // and clear the importCareOfName1 and importCareOfName2
        this.selectedObject = { ...fromCrud };
        if (!this.selectedObject.importName1) {
          this.selectedObject.name1 = this.selectedObject.importCareOfName1 || '';
          this.selectedObject.importName1 = this.selectedObject.importCareOfName1 || '';
          this.selectedObject.importCareOfName1 = '';
        }
        if (!this.selectedObject.importName2) {
          this.selectedObject.name2 = this.selectedObject.importCareOfName2 || '';
          this.selectedObject.importName2 = this.selectedObject.importCareOfName2 || '';
          this.selectedObject.importCareOfName2 = '';
        }
      }
      // Name/percent/C-O text belongs only on importAddress1 (set above) — importCareOfName1
      // must not also be written here, otherwise the name ends up saved in both places.
      // if (this.addPercentToCareOfNamesFromAssessor
      //     && this.selectedObject.importCareOfName1
      //     && !this.selectedObject.importCareOfName1.startsWith('%')) {
      //   this.selectedObject = { ...this.selectedObject, importCareOfName1: `%${this.selectedObject.importCareOfName1}` };
      // }
      this.consolidatedView = this.handleConsolidateView();
      // Compute assessor consolidated from ORIGINAL (unmodified) fromCrud data so the panel
      // always shows what the assessor actually sent, not our suggested address injection.
      const originalAssessorData = { ...fromCrud };
      if (this.addPercentToCareOfNamesFromAssessor
          && originalAssessorData.importCareOfName1
          && !originalAssessorData.importCareOfName1.startsWith('%')) {
        originalAssessorData.importCareOfName1 = `%${originalAssessorData.importCareOfName1}`;
      }
      this.assessorConsolidatedView = this.handleAssessorConsolidateView(originalAssessorData);
    },
    unpaidsCheckBoxClick(val) {
      // will be considering 2 for false and 1 for true
      let inputValue = 2;
      if (val) inputValue = 1;
      this.dynamicUpdateInputsValues = { type: 'constant', prop: 'assessorIgnoreTaxPaidFlag', value: inputValue };
    },
    getConsolidatedDeeddetails() {
      const deedArray = [];
      const {
        importDeedBk, importDeedPg, importGrantorName, importSaleDate,
      } = this.selectedObject;
      let saleDate = '';
      if (importSaleDate) saleDate = toShortDate(importSaleDate);
      // \u00A0 is a non-breaking space, as html usally removes the spaces between the words
      deedArray.push(`Deed Book: ${importDeedBk || '\u00A0'.repeat(10)} Deed Page: ${importDeedPg || ''}`);
      deedArray.push(`Grantor Name: ${importGrantorName || ''}`);
      deedArray.push(`Date: ${saleDate}`);
      return deedArray.join('\n');
    },
  },
  watch: {
    /* The listing is a live FTP connection, so it is made once, the first time the box
       is actually going to be shown - not on created(), where it fired at every county
       whether or not it had a folder to read. */
    landmarkFtpApplies: {
      immediate: true,
      handler(applies) {
        if (!applies || this.landmarkFtpLoaded) return;
        this.landmarkFtpLoaded = true;
        this.loadLandmarkFtpFiles();
      },
    },
  },
  beforeDestroy() {
    this.stopSecondPassPolling();
  },
};
</script>

<style scoped>
/* The fill and border follow the theme vars from assets/style.css rather than literals -
   the old `#fff` box survived the switch to the dark theme unchanged, so Vuetify's white
   field labels and values inside it were white-on-white and the panel read as an empty
   card. Light values stay as the var fallbacks, so the light theme is untouched.
   was: border: 1px solid #000; background-color: #fff; */
.landmark-ftp-box {
  border: 1px solid var(--panel-surface-border, #000000);
  background-color: var(--panel-surface-bg, #ffffff);
  /* keeps a long selected file name from pushing the Unzip button past the border */
  overflow: hidden;
}
</style>
